<esg-score-impact
	[metricsData]="industryInvolvementImpact"
	titleDcrKey="ESG_INDUSTRY_INVOLVEMENT_TITLE"
	subtitleDcrKey="ESG_INDUSTRY_INVOLVEMENT_SUBTITLE"
	disclosureDcrKey="ESG_INDUSTRY_INVOLVEMENT_DISCLOSURE"
></esg-score-impact>
